<template>
  <section>
<!--    <h4 class="form-card-header">{{ $t('registration.id-card-info') }}</h4>-->
    <form ref="form" action="/user/profile" method="POST" enctype="multipart/form-data" class="form-card-form">
      <input type="hidden" name="_token" :value="csrf" />
      <div>
        <image-input db-name="ids_front" id="front" ref="front" @return="getFront" :label="isChild ? `${$t('registration.front-bc')}` : `${$t('registration.front')}`"></image-input>
        <div class="text-red-400 text-sm" v-show="v$.form.frontPic.$errors.length">
          <div class='text-red' v-show="!v$.form.frontPic.$errors.required">{{ $t('helper.front-of-id-card') }}</div>
        </div>
      </div>

      <div>
        <image-input db-name="ids_back" id="back" ref="backImage" @return="getBack" :label="isChild ? `${$t('registration.back-bc')}` : `${$t('registration.back')}`"></image-input>
        <div class="text-red-400 text-sm" v-show="v$.form.backPic.$errors.length">
          <div class='text-red' v-show="!v$.form.backPic.$errors.required">{{ $t('helper.back-of-id-card') }}</div>
        </div>
      </div>

      <div>
        <image-input db-name="ids_selfie" id="selfie" ref="selfie" @return="getSelfie" :label="isChild ? `${$t('registration.selfie-bc')}` : `${$t('registration.selfie')}`"></image-input>
        <div class="text-red-400 text-sm" v-show="v$.form.selfie.$errors.length">
          <div v-show="!v$.form.selfie.$errors.required">
            <span class='text-red' v-if="isChild">{{ $t('helper.selfie-of-parent') }}</span>
            <span class='text-red' v-else>{{ $t('helper.selfie-of-id-card') }}</span>
          </div>
        </div>
      </div>

      <div>
        <image-input db-name="ids_signature" id="signature" ref="signature" @return="getSignature" :label="$t('registration.signature')"></image-input>
        <div class="text-red-400 text-sm" v-show="v$.form.signature.$errors.length">
          <div class='text-red' v-show="!v$.form.signature.$errors.required">{{ $t('helper.signature-of-id-card') }}</div>
        </div>
      </div>

      <section class="sub-step-buttons-container justify-content-end">
        <ic-button size="tn" type='button' @click='submit'>
          Илгээх
        </ic-button>
      </section>

<!--      <section class="sub-step-buttons-container">-->
<!--        <ic-button size="tn" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>Буцах</ic-button>-->
<!--        <ic-button size="tn" type="submit" variant="success"  @click="finish()" class="d-flex align-items-center ml-3">Дуусгах <i class="sr sr-chevron-right"></i></ic-button>-->
<!--      </section>-->
    </form>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import ImageInput from '../global/ImageInput'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    ImageInput,
  },
  props: {
    csrf: { String },
    isChild: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        frontPic: null,
        backPic: null,
        selfie: null,
        signature: null,
      }
    }
  },
  validations() {
    return {
      form: {
        frontPic: { required },
        backPic: { required },
        selfie: { required },
        signature: {  },
      }
    }
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async finish() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$emit('next', this.form)
      } else {
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      // window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async submit() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        this.$refs.form.submit()
      } else {
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
    },
    getFront(value) {
      this.form.frontPic = value
      this.v$.form.frontPic.$model = value
    },
    getBack(value) {
      this.form.backPic = value
      this.v$.form.backPic.$model = value
    },
    getSelfie(value) {
      this.form.selfie = value
      this.v$.form.selfie.$model = value
    },
    getSignature(value) {
      this.form.signature = value
      this.v$.form.signature.$model = value
    },
  }
}
</script>